import React, { useState } from "react";
import { CalendarDays, ExternalLink, Phone } from "lucide-react";
import { BOOKING_URL } from "../lib/i18n";

export const BookingCard = ({ embedUrl, lang }) => {
  const [open, setOpen] = useState(true);
  const no = lang === "no";
  const href = embedUrl || BOOKING_URL;
  return (
    <div data-testid="chat-booking-card" className="mt-3 mb-5 border border-ink bg-paper rounded-[2px] shadow-[4px_4px_0_0_#D35400] animate-fade-up">
      <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-ink/70">
        <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase text-ember">
          <CalendarDays size={14} /> {no ? "Book en prat med Nickolass" : "Book a call with Nickolass"}
        </div>
        {embedUrl && (
          <button data-testid="chat-booking-toggle" onClick={() => setOpen(!open)}
            className="font-mono text-[10px] tracking-[0.18em] uppercase text-mist hover:text-ember">
            {open ? (no ? "skjul" : "hide") : (no ? "vis kalender" : "show calendar")}
          </button>
        )}
      </div>
      {embedUrl && open && (
        <iframe
          data-testid="chat-booking-iframe"
          title="booking"
          src={embedUrl}
          loading="lazy"
          className="w-full h-[380px] md:h-[420px] bg-white"
        />
      )}
      <div className="flex flex-wrap items-center gap-2 px-4 py-3">
        <a data-testid="chat-booking-link" href={href} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ink text-paper font-mono text-[11px] tracking-[0.18em] uppercase hover:bg-ember transition-colors">
          <ExternalLink size={13} /> {embedUrl ? (no ? "Åpne i ny fane" : "Open in new tab") : (no ? "Velg tid" : "Pick a time")}
        </a>
        <a data-testid="chat-booking-phone" href="tel:+4740043101"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-ink font-mono text-[11px] tracking-[0.18em] uppercase hover:bg-sand transition-colors">
          <Phone size={13} /> +47 400 43 101
        </a>
      </div>
    </div>
  );
};
